import React, { useEffect, useRef, useCallback, useState, useMemo } from 'react';
import './BrowserTop.css';
import { f_isSignInWithEmailLink, f_signInWithEmailLink, auth, signIn } from '../Util/Firebase';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { ReactComponent as CopyLinkSVG } from '../Images/buttons/linkCopyGray.svg';
import { ReactComponent as NewMeetingSVG } from '../Images/buttons/newMeetingButton.svg';
import { ReactComponent as JoinSVG } from '../Images/buttons/join.svg';
import { ReactComponent as RecordSVG } from '../Images/buttons/record.svg';
import { ReactComponent as PlusSVG } from '../Images/buttons/plusBleck.svg';
import { ReactComponent as LogoSVG } from '../Images/header/logoBlack.svg';
import { ReactComponent as JoinTopSVG } from '../Images/buttons/joinTopButton.svg';
import { ReactComponent as StartSVG } from '../Images/buttons/startIcon.svg';
import { ReactComponent as SettingSVG } from '../Images/header/settingBlack.svg';
import { ReactComponent as RecordedListSVG } from '../Images/buttons/recordListButton.svg';
import { ReactComponent as PlaceholderSVG } from '../Images/buttons/placeholder-mypage.svg';
import { ReactComponent as RecordSmallSVG } from '../Images/buttons/recordButtonSmall.svg';
import { ReactComponent as SmileLogoSVG } from '../Images/header/smilelogo.svg';
import { ReactComponent as DownloadSVG } from '../Images/header/download.svg';
import { ReactComponent as MenuSVG } from '../Images/buttons/menuTop.svg';
import AddAccess from '../Util/AddAccess';
import BrowserMenu from './BrowserMenu';
import { useTranslation } from 'react-i18next';

import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import {
  isAuthAtom,
  topMessageAtom,
  isAuthLoadedAtom,
  pageAtom,
  myNftAtom,
  displayNameAtom,
  myNftBackAtom,
} from '../../State';
import DataModel from '../Util/DataModel';
import AuthCheck from '../../AuthCheck';
import ShowMessage from '../Header/ShowMessage';
import Setting from '../Setting/Setting';
import BrowserFace from './BrowserFace';
import BrowserEmail from './BrowserEmail';
import BrowserJoin from './BrowserJoin';
import FaceImage from '../Setting/FaceImage';
import Loading from '../Loading/Loading';
import AddLive from './AddLive';
import RecordedList from './RecordedList';
import ListItem from './ListItem';
import RecordedItem from './RecordedItem';
import AddArea from './AddArea';
import ShowLive from './ShowLive';
import { reload } from 'firebase/auth';
import Error from './Error';
import DownloadApp from './DownloadApp';
import { Menu } from '@mui/material';
import { getImagePath } from '../Util/utils';
import BrowserMyRoom from './BrowerMyRoom';

export default function ElectronTop({ verify = false }) {
  const navigate = useNavigate(); //リダイレクト用
  const { t, i18n } = useTranslation();

  //Recoil系
  const [authState, setAuthState] = useRecoilState(isAuthAtom);
  const [isAuthLoadedState, setIsAuthLoadedState] = useRecoilState(isAuthLoadedAtom);
  const setTopMessageState = useSetRecoilState(topMessageAtom);
  const [pageState, setPageState] = useRecoilState(pageAtom);
  const [myNftState, setMyNftState] = useRecoilState(myNftAtom);
  const [displayNameState, setDisplayNameState] = useRecoilState(displayNameAtom);
  const myNftBackState = useRecoilValue(myNftBackAtom);
  const defaultBack = 'whiteYellow.png';

  //その他
  const [tabState, setTabState] = useState('meetings');
  const [isLoadedState, setIsLoadedState] = useState(false);
  const [meetingIDState, setMeetingIDState] = useState(null);
  const [showJoin, setShowJoin] = useState(false);
  const [showLive, setShowLive] = useState(false);
  const [showLiveState, setShowLiveState] = useState(null);
  const [showLiveButton, setShowLiveButton] = useState(false);
  const [showRecordedList, setShowRecordedList] = useState(false);
  const [hatenaState, setHatenaState] = useState(false);
  const [loadingState, setLoadingState] = useState(false); //ローディングアイコン表示用
  const liveRoomID = useRef(null);
  const [recordedVideoArray, setRecordedVideoArray] = useState([]);
  const [showAddArea, setShowAddArea] = useState(false);
  const [showError, setShowError] = useState(null);
  const [meetingListState, setMeetingListState] = useState([]);
  const [roomID, setRoomID] = useState(null);
  const [backState, setBackState] = useState(null);

  //ルートから
  const location = useLocation();
  const [comefromExitState, setComeFromExitState] = useState(location.state);
  const urlParam = useParams();

  //設定型
  const [showMenu, setShowMenu] = useState(false);

  useEffect(() => {
    //emailLinkCheck();
    if (verify) {
      tokenCheck();
    }

    AddAccess('page-view', 'mypage');
  }, []);

  useEffect(() => {
    if (authState == false) return;
    //ミーティング一覧を取得
    if (tabState == 'meetings') {
      getMeetingID();
      getMeetingList();
    }
    //録画一覧を取得
    else {
      getRecordedList();
    }
  }, [tabState, authState]);

  useEffect(() => {
    showProfileImage();
  }, [myNftState]);

  useEffect(() => {
    setTimeout(() => {
      loadBack();
    }, 200);
  }, [myNftBackState]);

  //Load background image
  async function loadBack() {
    var finalURL;

    if (localStorage.getItem('backImageURL') != null) {
      finalURL = localStorage.getItem('backImageURL');
    } else {
      if (myNftBackState == null) {
        finalURL = defaultBack;
      } else {
        finalURL = myNftBackState;
      }
    }

    try {
      //カスタム背景の場合
      if (finalURL.startsWith('custom')) {
        let baseURL = 'https://storage.googleapis.com/faceless-97bcf.appspot.com/mybackground/';
        finalURL = baseURL + finalURL;
      } else if (finalURL == 'h4.jpg') {
        finalURL = 'https://faceless.hiho.jp/background/back.png';
      } else {
        finalURL = getImagePath() + '/background/' + finalURL;
      }

      setBackState(finalURL);
    } catch (e) {
      setBackState(null);
    }
  }

  useEffect(() => {
    //ライブ状況取得
    // liveCheck();
    // console.log(showLiveState);
  }, [showLiveState]);
  //Exitから来た場合のみ表示（リロードやダイレクトアクセスの場合は動作しない）
  useEffect(() => {
    if (comefromExitState != null && comefromExitState.comeFromExit) {
      setTopMessageState({
        type: 'joined',
        message: t('top.Left the call'),
      });

      //履歴を書き換えて再度表示されないように
      window.history.replaceState(null, '', window.location.href);
      window.history.pushState(null, '', window.location.href);
    }
  }, [comefromExitState]);

  //リロード
  async function callReload() {
    getMeetingList(true);
  }

  async function callRecordedReload() {
    getRecordedList(true);
  }

  //トークンチェック
  async function tokenCheck() {
    //DB確認するまでローディングを表示
    setLoadingState(true);

    //トークン
    var token = urlParam.token;

    //コードの確認
    const result = await DataModel.checkEmailToken(token, i18n.language);

    if (result != null) {
      if (result.status == 'expired') {
        setTopMessageState({
          type: 'joined',
          message: t('mypage.The link has expired'),
        });
        setLoadingState(false);
        return;
      }

      //ログイン処理
      //const auth = getAuth();

      //ミーティングIDをローカルに保存
      localStorage.setItem('meetingID', result.meetingID);

      //トークンでのログイン
      signIn(auth, result.token)
        .then((result) => {
          console.log('ログインした');

          //送信中フラグオフ
          setLoadingState(false);

          setTopMessageState({
            type: 'joined',
            message: t('mypage.Logged in!'),
          });

          // window.location.href = 'https://faceless.ooo/app';
        })
        .catch((error) => {
          console.log('エラーだよ');
          console.log(error);
        });
    } else {
      //送信中フラグオフ
      setLoadingState(false);

      //エラーメッセージ
      setTopMessageState({
        type: 'joined',
        message: t('mypage.Error something wrong'),
      });
    }
  }

  //メール内リンクをクリックして戻ってきた場合の処理
  async function emailLinkCheck() {
    //メール内リンクからクリックして来た時の処理
    if (f_isSignInWithEmailLink(auth, window.location.href)) {
      //DB確認するまでローディングを表示
      setLoadingState(true);

      //ローカルに保存されているメールアドレス
      let email = window.localStorage.getItem('emailForSignIn');
      if (!email) {
        email = window.prompt(t('mypage.Please provide your email for confirmation'));
      }
      f_signInWithEmailLink(auth, email, window.location.href)
        .then(async () => {
          //ログイン成功

          //DBへの追加とミーティングID取得
          const result = await DataModel.signUpWithEmail(email, i18n.language);

          //エラーの場合
          if (result == null) {
            //エラー
            alert(t('mypage.There is an error, please try from the beginning'));
          } else {
            //ミーティングIDをローカルに保存
            localStorage.setItem('meetingID', result.meetingID);

            //ローカルストレージを削除
            window.localStorage.removeItem('emailForSignIn');

            window.location.href = 'https://faceless.ooo/app';
          }

          setLoadingState(false);
        })
        .catch((error) => {
          //エラー
          alert(t('mypage.There is an error, please try from the beginning'));
          setLoadingState(false);
        });
    }
  }

  async function getMeetingID() {
    //console.log('ここきた');
    //console.log(localStorage.getItem('meetingID'));
    if (localStorage.getItem('meetingID') == null || localStorage.getItem('meetingID') == '') {
      const meetingID = await DataModel.getUserData('meetingID');

      if (meetingID != null) {
        //ローカルストレージに保存
        localStorage.setItem('meetingID', meetingID);

        //ミーティングIDを設定
        setMeetingIDState(meetingID);
      }
    } else {
      //ミーティングIDを設定
      setMeetingIDState(localStorage.getItem('meetingID'));
    }
  }

  //ミーティングリスト取得
  async function getMeetingList(reload = false) {
    var result = await DataModel.getMeetingList();
    if (result != null) {
      if (reload) {
        setMeetingListState([]);
        setTimeout(() => {
          setMeetingListState(result);
        }, 10);
      } else {
        setMeetingListState(result);
      }
    } else {
      setMeetingListState([]);
    }
  }

  //liveモードの状態を確認
  async function liveCheck() {
    var roomID = await DataModel.checkLiveStatus();
    if (roomID != null) {
      liveRoomID.current = roomID;
      setShowLiveButton(true);
    } else {
      setShowLiveButton(false);
    }
  }

  //liveモードの状態を確認
  async function getRecordedList(reload) {
    var recordedVideos = await DataModel.checkRecordedVideo();

    if (recordedVideos != null) {
      if (reload) {
        setRecordedVideoArray([]);
        setTimeout(() => {
          setRecordedVideoArray(recordedVideos);
        }, 100);
      } else {
        setRecordedVideoArray(recordedVideos);
      }
    } else {
      setRecordedVideoArray([]);
    }
  }

  //認証
  useMemo(() => {
    if (localStorage.getItem('isAuth') != null && localStorage.getItem('isAuth')) {
      setAuthState(true);
    }

    //初期化
    init();
  }, []);

  function init() {
    if (localStorage.getItem('displayName') != null) {
      setDisplayNameState(localStorage.getItem('displayName'));
    }
  }

  function showProfileImage() {
    if (localStorage.getItem('nftID') != null) {
      setMyNftState(localStorage.getItem('nftID'));
    } else {
    }
  }

  //録画
  const recordScreen = async () => {
    navigate('/record');
  };

  //参加
  const joinMeeting = async () => {
    setShowJoin(true);
  };

  //新しいミーティング
  const showLiveForm = async () => {
    setShowLive(true);
  };

  //顔をタップ
  const tapFace = async () => {
    //  setPageState('nftList');
    navigate('/face');
    AddAccess('page-view', 'faceSelect');
  };

  //クリップボードにコピー
  const copyURL = () => {
    const url = 'https://faceless.ooo/' + meetingIDState;
    navigator.clipboard.writeText(url).then(
      function () {
        setTopMessageState({ type: 'copied', message: t('top.Copied Successfully') });

        AddAccess('click', 'copiedURL');
      },
      function (err) {},
    );
  };

  const showSetting = async () => {
    setPageState('setting');
  };

  const showFeedback = async () => {
    AddAccess('page-view', 'feedback');
    navigate('/feedback');
  };

  const clickAdd = async () => {};

  return (
    <>
      {/* 認証 */}
      <AuthCheck />

      {/*　ローディング */}
      <Loading loadingState={loadingState} />

      {/* 設定画面 */}
      {pageState == 'setting' ? <Setting /> : ''}

      {/* 顔選択画面 */}
      {pageState == 'faceSelect' ? <BrowserFace /> : ''}

      {/* ダウンロードアプリ */}
      {pageState == 'downloadApp' && <DownloadApp />}

      {/* ヘッダーのメッセージ */}
      <ShowMessage />

      {/* ライブ追加画面 */}
      {showLive && <AddLive setShowLive={setShowLive} roomID={liveRoomID.current} />}

      {/* ローディング画面 */}
      {isAuthLoadedState == false && (
        <>
          {/* <div id="electronLoadingBack"></div>
          <div id="electronLoadingBody">
            <img src="/images/header/logoDummyLeft.svg" />
          </div> */}
        </>
      )}

      {/* ヘッダー */}
      <div id="browserHeader">
        <div id="browserHeaderLogo" onClick={() => window.location.reload()}>
          {/* <SmileLogoSVG /> */}
          {/* <img src="https://d2wp3sepl8g4xv.cloudfront.net/hp/images/logo.png" alt="Photo" /> */}
        </div>

        <div className="menu-area">
          <ul>
            <li>{/* <a onClick={showFeedback}>{t('setting.Feedback')}</a> */}</li>

            {/* <li>
              <a
                onClick={() => {
                  window.location = 'https://faceless.ooo/faq';
                }}>
                {t('setting.FAQ')}
              </a>
            </li> */}

            <li
              className="downloadMenu"
              onClick={() => {
                setPageState('downloadApp');
              }}>
              <DownloadSVG /> <button>{t('mypage.Download App')}</button>
            </li>

            {/* <li className="setting" onClick={showSetting}>
              <img src="/images/header/settingWhite.svg" />
            </li> */}
          </ul>
        </div>
      </div>

      <div id="electronWrap">
        <div id="electronTop">
          {/* エラー画面 */}
          {showError != null && <Error showError={showError} setShowError={setShowError} />}

          {/* ログイン画面 */}
          {authState == false && <BrowserEmail />}

          {/* 参加画面画面 */}
          {showJoin && <BrowserJoin setShowJoin={setShowJoin} />}

          {/* My Meeting Room */}
          {pageState == 'myMeetingRoom' && (
            <BrowserMyRoom meetingIDState={meetingIDState} setMeetingIDState={setMeetingIDState} />
          )}

          {/* 追加画面 */}
          <AddArea
            showAddArea={showAddArea}
            setShowAddArea={setShowAddArea}
            callReload={callReload}
            setRoomID={setRoomID}
            setShowLiveState={setShowLiveState}
            setShowError={setShowError}
            meetingIDState={meetingIDState}
          />

          {/* 設定 */}
          <BrowserMenu
            showMenu={showMenu}
            setShowMenu={setShowMenu}
            meetingIDState={meetingIDState}
          />

          {/* ライブ追加 */}
          {showLiveState == 'new' ||
          showLiveState == 'edit' ||
          showLiveState == 'newMeeting' ||
          showLiveState == 'editMeeting' ? (
            <AddLive
              roomID={roomID}
              setRoomID={setRoomID}
              showLiveState={showLiveState}
              setShowLiveState={setShowLiveState}
              callReload={callReload}
            />
          ) : (
            <></>
          )}

          {/* ライブ詳細 */}
          {showLiveState == 'detail' && (
            <ShowLive
              roomID={roomID}
              setRoomID={setRoomID}
              showLiveState={showLiveState}
              setShowLiveState={setShowLiveState}
            />
          )}

          <div id="electronHeader">
            <div
              id="electronHeaderMenu"
              onClick={() => {
                setShowMenu(true);
              }}>
              <MenuSVG />
            </div>
            <div id="electronHeaderImage">
              <LogoSVG />
            </div>

            {/* <div id="electronHeaderSetting" onClick={showSetting}>
              <SettingSVG />
            </div> */}
          </div>
          <div id="electronWrapBack">
            <div id="electronWrapBackImage" onClick={tapFace}>
              <img src={backState} />
            </div>
            <div
              id={
                myNftState != null && myNftState.startsWith('custom')
                  ? 'electronWrapImage'
                  : 'electronWrapImage'
              }
              onClick={tapFace}>
              <FaceImage myNftState={myNftState} />
            </div>

            <div id="electronWrapRecord" onClick={recordScreen}>
              <RecordSmallSVG />
              <span>{t('mypage.Record')}</span>
            </div>
          </div>

          <div className="topMeetingButtons">
            <div
              className="topMeetingButtonItem topMeetingButtonStart"
              onClick={() => setShowAddArea(true)}>
              <StartSVG />
              <span>{t('mypage.Start')}</span>
            </div>
            <div className="topMeetingButtonItem topMeetingButtonJoin" onClick={joinMeeting}>
              <JoinTopSVG />
              <span>{t('mypage.Join')}</span>
            </div>
          </div>

          <div className="topMeetingTab">
            <div
              onClick={() => setTabState('meetings')}
              className={
                tabState == 'meetings' ? 'topMeetingTabItem selected' : 'topMeetingTabItem'
              }>
              {t('mypage.Schedule')}
            </div>
            <div
              onClick={() => setTabState('recorded')}
              className={
                tabState == 'recorded' ? 'topMeetingTabItem selected' : 'topMeetingTabItem'
              }>
              {t('mypage.MeetingTabRecorded')}
            </div>
          </div>
          <div className="topMeetingList">
            {/* <div className="gradientBottom">
              <GradientSVG />
            </div> */}
            {tabState == 'meetings' ? (
              <>
                {/* {meetingIDState != null && (
                  <ListItem
                    key={'uniquekey'}
                    meeting={{ roomName: meetingIDState, roomType: 'personal' }}
                    callReload={callReload}
                    setRoomID={setRoomID}
                    setShowLiveState={setShowLiveState}
                    setShowError={setShowError}
                    setMeetingIDState={setMeetingIDState}
                  />
                )} */}

                {meetingListState.length == 0 && (
                  <div className="meetingListPlaceholder">{/* <PlaceholderSVG /> */}</div>
                )}
                {meetingListState.length > 0 && (
                  <>
                    {meetingListState.map((meeting, index) => (
                      <>
                        <ListItem
                          key={index}
                          meeting={meeting}
                          callReload={callReload}
                          setRoomID={setRoomID}
                          setShowLiveState={setShowLiveState}
                          setShowError={setShowError}
                        />
                      </>
                    ))}
                  </>
                )}
              </>
            ) : (
              <>
                {recordedVideoArray.length == 0 && (
                  <div className="meetingListPlaceholder">
                    <PlaceholderSVG />
                  </div>
                )}

                {recordedVideoArray.length > 0 && (
                  <>
                    {recordedVideoArray.map((recorded, index) => (
                      <>
                        <RecordedItem
                          key={index}
                          meeting={recorded}
                          callRecordedReload={callRecordedReload}
                          setShowError={setShowError}
                        />
                      </>
                    ))}
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
